import Users from "./views/Users.vue";
import AddUser from "./views/AddUser.vue";
import EditUser from "./views/EditUser.vue";

export default [
  {
    path: "/usermenu",
    component: Users,
    name: "usermenu",
    menu: {
      section: "Admin",
      icon: "group",
      title: "Usuarios",
      scope: ["admin"],
    },
    meta: { isAuthenticated: true },
  },
  {
    path: "/adduser",
    component: AddUser,
    scope: ["admin"],
    name: "adduser",
    meta: { isAuthenticated: true },
  },
  {
    path: "/users/edit/:id",
    component: EditUser,
    name: "edituser",
    meta: { isAuthenticated: true },
  },
];



// WEBPACK FOOTER //
// ./src/components/users/routes.js